export default "__VITE_ASSET__babe0b56__"